module.exports = __webpack_public_path__ + "hero-mobile@2x.cabdb5acf435299aea4aaf5419d35102.png";


//////////////////
// WEBPACK FOOTER
// ./components/hero/assets/hero-mobile@2x.png
// module id = Jtto
// module chunks = 0